export const TOTAL_PAYABLE_TEXT = "Total Payable Amount";
